import './pageTemplate.scss'

import {graphql} from 'gatsby'
import React from 'react'

import Layout from '../components/layout/Layout'
import SEO from '../components/seo'
import SectionTitle from '../components/ui/SectionTitle'

/**
 * This is a template that can be used from gatsby-node.js to create pages from .md files
 *
 * @param props The data provided by the gatsby-node.js config to generate pages
 */
export default function PageTemplate({
  data, // this prop will be injected by the GraphQL query below.
}) {
  const {markdownRemark} = data // data.markdownRemark holds your post data
  const {frontmatter, html} = markdownRemark
  return (
    <>
      <SEO title={frontmatter.title} />
      <Layout>
        <section className="max-w-5xl px-5 py-10 mx-auto lg:p-16" id="markdown-content">
          <SectionTitle title={frontmatter.title} variant="large" />
          <div className="blog-post-content" dangerouslySetInnerHTML={{__html: html}} />
        </section>
      </Layout>
    </>
  )
}

export const pageQuery = graphql`
  query ($slug: String!) {
    markdownRemark(frontmatter: {slug: {eq: $slug}}) {
      html
      frontmatter {
        slug
        title
      }
    }
  }
`
